import React, {PureComponent} from "react"
import {Route, withRouter, RouteComponentProps} from "react-router-dom"
import Loading from "@irati/ui/src/Loading"
import {hangPromise} from "@irati/utils/promise"

interface Props extends RouteComponentProps {
  routes: () => Promise<any>
  path?: string
  routeProps?: any
}

interface MountedRoutesProps {
  routes: () => Promise<any>
  children: (props: {load: Promise<any>; resolvedRoutes: any}) => any
}

interface State {
  resolvedRoutes: any
  load: Promise<any>
}

class MountedRoutes extends PureComponent<MountedRoutesProps, State> {
  state = {
    load: hangPromise(),
    resolvedRoutes: () => null
  }

  componentDidMount() {
    this.setState({
      load: this.props.routes().then((routes) => {
        this.setState({resolvedRoutes: routes.default})
      })
    })
  }

  render() {
    return this.props.children({load: this.state.load, resolvedRoutes: this.state.resolvedRoutes})
  }
}

/* eslint-disable react/no-multi-comp */
class LazyLoad extends PureComponent<Props> {
  render() {
    const {path} = this.props
    const {routeProps = {path}} = this.props

    return (
      <Route
        path={path}
        render={() => (
          <>
            <MountedRoutes routes={this.props.routes}>
              {({load, resolvedRoutes: Routes}) => (
                <Loading load={load}>
                  <Routes {...routeProps} />
                </Loading>
              )}
            </MountedRoutes>
          </>
        )}
      />
    )
  }
}
/* eslint-enable react/no-multi-comp */
export default withRouter(LazyLoad)
